export enum Configs {
  DRAWER_SIGNIN = "drawer_signin",
  MAIN_MENU_BUTTON = "main_menu_button",
  AVATAR_AUTHENTICATION = "avatar_authentication",
  ACCOUNT_CREATION = "account_creation",
  CONFIG_NAVIGATION = "config_navigation",
  AVATAR_DIALOG = "avatar_dialog",
  WAITER_BUTTON = "waiter_button",
  ADD_ORDER = "add_order",
}

export const remoteConfigInitialValues = {
  [Configs.DRAWER_SIGNIN]: false,
  [Configs.MAIN_MENU_BUTTON]: false,
  [Configs.AVATAR_AUTHENTICATION]: false,
  [Configs.ACCOUNT_CREATION]: false,
  [Configs.CONFIG_NAVIGATION]: false,
  [Configs.AVATAR_DIALOG]: false,
  [Configs.WAITER_BUTTON]: false,
  [Configs.ADD_ORDER]: false,
};

export const DEFAULT_MENU_TEMPLATE = 'ToKMxmVapOJpdYh5k5X0';
export const DEFAULT_WEBSITE_TEMPLATE = 'f8Ki2hlwl5OQqXQPAZv0';
